import NFTSectionsMenuItems from './NFTSectionsMenuItems'

export default NFTSectionsMenuItems
